import {
  ELSTokenServiceRegistrar,
} from '@els/els-ui-common-react';
import {
  storeRefreshToken,
  clearRefreshToken,
} from './refresh-token.utilities';
import { TokenRotationResponse } from '../types/token.types';

export const storeTokens = (tokens: TokenRotationResponse): void => {
  ELSTokenServiceRegistrar.register(tokens.eolsToken);
  storeRefreshToken(tokens.refreshToken);
};

export const clearAllTokens = (): void => {
  ELSTokenServiceRegistrar.unRegister();
  clearRefreshToken();
};
